var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.728 10.1309L9.18523 0.939453C8.82261 0.355469 8.20099 0 7.50166 0C6.80234 0 6.18071 0.355469 5.8181 0.939453L0.275288 10.1309C-0.0873258 10.7148 -0.0873259 11.4512 0.249387 12.0352C0.612001 12.6445 1.23362 13 1.93295 13H13.0445C13.7438 13 14.3913 12.6445 14.728 12.0352C15.0907 11.4512 15.0907 10.7148 14.728 10.1309ZM8.27869 10.2578C8.27869 10.6895 7.94198 11.0195 7.50166 11.0195C7.06135 11.0195 6.72463 10.6895 6.72463 10.2578V10.0039C6.72463 9.57227 7.06135 9.24219 7.50166 9.24219C7.94198 9.24219 8.27869 9.57227 8.27869 10.0039V10.2578ZM8.27869 8.09961C8.27869 8.53125 7.94198 8.86133 7.50166 8.86133C7.06135 8.86133 6.72463 8.53125 6.72463 8.09961V4.03711C6.72463 3.60547 7.06135 3.27539 7.50166 3.27539C7.94198 3.27539 8.27869 3.60547 8.27869 4.03711V8.09961Z",
    fill: "#C05600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPending);
export default __webpack_public_path__ + "static/media/account-pending.1015df9056b7bc3c8d784d7519eb6e33.svg";
export { ForwardRef as ReactComponent };